// ======================================================================
// File Name       : LoginScreenSetting
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Col, Form } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';

class LoginScreenSetting extends Component {
  render() {
    const { formValues } = this.props;

    let loginSetting = null;
    if (formValues && formValues.values) {
      const { loginBackgroundFlag, loginPanelLogoFlag } = formValues.values;
      loginSetting = (
        <>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col as={Form.Label} sm={2}>ログイン背景画像</Col>
              <Col className="margin-top-7" sm={2}>
                <RenderField
                  type="checkbox"
                  name="loginBackgroundFlag"
                  label="表示する"
                  normalizeRadio
                  value={loginBackgroundFlag}
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col as={Form.Label} sm={2}>ログインパネルロゴ画像</Col>
              <Col className="margin-top-7" sm={2}>
                <RenderField
                  type="checkbox"
                  name="loginPanelLogoFlag"
                  label="表示する"
                  normalizeRadio
                  value={loginPanelLogoFlag}
                />
              </Col>
            </Col>
          </Form.Group>
        </>
      );
    }
    return <div>{loginSetting}</div>;
  }
}

export default LoginScreenSetting;
